module.exports = __webpack_public_path__ + "static/media/copyWhite.d765545a.svg";